import { track } from "@amplitude/analytics-react-native";
import { useApolloClient } from "@apollo/client";
import { useEffect, useRef } from "react";
import { amp } from "src/api/amplitude";
import GetClientProfileFacialRecognitionReadyInfoDocument from "src/api/graphql/__generated__/documents/GetClientProfileFacialRecognitionReadyInfoDocument";
import { useGatheringStore } from "src/contexts/GatheringContext";
import { useClientId } from "src/helpers/globalHelpers";
import useRouter from "src/hooks/useRouter";
import { alert } from "src/swsh-native";

const MissingFacialRecognitionPopUp = () => {
	const clientId = useClientId();
	const isFiltered = useGatheringStore((store) => store.filterUserIds.includes(clientId));
	const router = useRouter();
	const apolloClient = useApolloClient();

	const didPrompt = useRef(false);
	const didHaveValid = useRef(false);
	const isMaybePrompting = useRef(false);
	useEffect(() => {
		if (!isFiltered) return;
		if (didHaveValid.current) return;
		if (didPrompt.current) return;
		(async () => {
			if (isMaybePrompting.current) return;
			try {
				isMaybePrompting.current = true;
				const { data } = await apolloClient.query({
					query: GetClientProfileFacialRecognitionReadyInfoDocument,
					fetchPolicy: "network-only",
				});
				if (isFiltered && !data?.getClientProfile?.facialRecognitionConsent) {
					didPrompt.current = true;
					track(amp.gathering.missing.facialRecognition.prompt);
					alert({
						title: "Missing Facial Recognition Consent",
						message:
							"We need your consent to use facial recognition to find you in photos! Please consent in Settings",
						buttons: [
							{
								text: "Ignore",
								style: "cancel",
								onPress: () => {
									track(amp.gathering.missing.facialRecognition.ignore);
								},
							},
							{
								text: "Settings",
								style: "default",
								isPreferred: true,
								onPress: () => {
									track(amp.gathering.missing.facialRecognition.settings);
									router.push("/settings");
								},
							},
						],
					});
				} else if (isFiltered && data?.getClientProfile?.hasFacePfp === false) {
					didPrompt.current = true;
					track(amp.gathering.missing.facePfp.prompt);
					alert({
						title: "Face Not Found",
						message: "Update your profile pic with a clear selfie in Settings",
						buttons: [
							{
								text: "Ignore",
								style: "cancel",
								onPress: () => {
									track(amp.gathering.missing.facePfp.ignore);
								},
							},
							{
								text: "Settings",
								style: "default",
								isPreferred: true,
								onPress: () => {
									track(amp.gathering.missing.facePfp.settings);
									router.push("/settings");
								},
							},
						],
					});
				} else {
					didHaveValid.current = true;
				}
			} finally {
				isMaybePrompting.current = false;
			}
		})();
	}, [apolloClient, isFiltered, router]);
	return null;
};
export default MissingFacialRecognitionPopUp;
